import { useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useMount } from 'ahooks';
import last from 'lodash/last';
import { ElIcon, useClassNames } from '@qsxy/element-plus-react';
import classNames from 'classnames';
import './style.scss';

const Setting = () => {
	const { b, is } = useClassNames('setting', 'ttn');
	const [active, setActive] = useState('userInfo');

	const location = useLocation();
	useMount(() => {
		if (location.pathname.startsWith('/setting')) {
			setActive(last(location.pathname.split('/')));
		}
	});

	return (
		<section className={classNames(b(), is('vertical'))}>
			<header className={b`header`}>我的设置</header>
			<section className={b()}>
				<aside className={b`aside`}>
					<NavLink to="userInfo">
						<div className={classNames('menu', is({ active: active === 'userInfo' }))} onClick={() => setActive('userInfo')}>
							<div className="icon">
								<ElIcon name="user" />
							</div>
							<div className="name">个人中心</div>
						</div>
					</NavLink>
					<NavLink to="safeSetting">
						<div className={classNames('menu', is({ active: active === 'safeSetting' }))} onClick={() => setActive('safeSetting')}>
							<div className="icon">
								<ElIcon name="shield-check" />
							</div>
							<div className="name">安全设置</div>
						</div>
					</NavLink>
				</aside>
				<main className={b`main`}>
					<Outlet />
				</main>
			</section>
		</section>
	);
};

export default Setting;
